// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__OSRfF","title":"Images45_title__Ldeb_","images":"Images45_images__3OI8k"};